import React, { Component } from 'react'

import styles from './style.css'

export default class Icon extends Component {
  render() {
    return (
      <i className={`${styles.icon} ${styles[this.props.name]}`} />
    )
  }
}



// WEBPACK FOOTER //
// ./src/SPRINTA/Topbar/atoms/Icon/index.js